import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { creator } from 'd3';
import { cloneDeep } from 'lodash';
import { MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants, ImageTypes } from 'src/app/services/global-constants';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-create-course',
  templateUrl: './create-course.component.html',
  styleUrls: ['./create-course.component.scss']
})
export class CreateCourseComponent {
filterFunctionByPostOuFilter($event: any) {
  this.selectedOus = $event.node;
}

  //Request data
  @Input() data: any = undefined;
  @Input() fromCreateTraining: boolean = false;
  @Input() isSkillTraining: boolean = false
  @Input() skillTypeId: string = "";
  @Input() formTrainingProgram: boolean = false;
  @Input() openComponent: boolean = false;
  @Input() programOu: any
  @Input() master_trainer: any
  @Output() trainingCreated: EventEmitter<any> = new EventEmitter<any>();


  loading: boolean = false

  @Input() newBranchTraining: boolean = false
  message: any = undefined

  createCourseForm: FormGroup | any;
  createSessionForm: FormGroup | any;
  createProgramForm: FormBuilder | any
  sectionTypeIdHolder: any
  trainingTypes: any[] = [];
  city: Array<Location | any> = [];
  dateType = "range";
  translator: TranslatorPipe = new TranslatorPipe()


  // file urls 
  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  courseImage: string = ''

  //file handlers
  fileName: any = ''
  courseMaterial: any = []

  videoUploadSpinner = false
  trainingMaterialImageType = ImageTypes.training_material

  // session types
  sessionTypes = [
    // { value: 'COURSE', label: 'Course', icon: 'pi pi-map-marker' },
    { value: 'SESSION', label: this.translate('Workshop'), icon: 'pi pi-map-marker' },
    { value: 'ASSESSMENT', label: this.translate('a test'), icon: 'pi pi-map-marker' },
    { value: 'SURVEY', label: this.translate('reconnaissance'), icon: 'pi pi-map-marker' }
  ]
  assessments: any = [];
  surveys: any = [];
  externalTrainers: any[] = [];
  internalTrainers: any[] = [];
  showInternal: boolean = true;
  addTrainerModal: boolean = false;
  trainer: any

  // From step handlers
  steps: any = [
    { title: this.translate('general information'), value: 1 },
    { title: this.translate('Create Course'), value: 5 },
  ]

  step: any = { title: this.translate('general information'), value: 1 }
  permissions: any;
  invalidDate!: string;


  allowedRight = ['Ministries/Entities', 'Organisational Units', 'Branches']
  selectedTreeData: any = []
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];


  changeRoute(route: any) {
    this.router.navigate([route]);

  }

  reloadPage() {

    window.location.reload()
  }

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private orgUnits: OrgUnitsService,
    private router: Router,
    @Inject(LOCALE_ID) private locale: string,
    public permissionService: PermissionHandlerService,
    // private cdr:ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.data?.type?.number_of_sessions == 1 ? this.dateType = "single" : this.dateType = "range";


    if (this.master_trainer && this.master_trainer != null && this.master_trainer != undefined) {
      this.trainer = this.master_trainer
    }

    console.log("====>training get", this.newBranchTraining)
    if (this.newBranchTraining) {
      this.getInternalTrainers()
    }

    Promise.all([this.constructForObject(), this.getTrainingTypes(),
      // ,this.getCity(),this.getSurveys(),this.getAssessments()
    ]).then(() => {
      this.getTreeData()
    })
  }


  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag)
  }

  internalExternal(type: any) {
    this.showInternal = !(type.checked == true)
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  handleUpdatedUserData(event: any) {
    this.getInternalTrainers()
  }


  materialUploadResponse(res: any) {
    if (typeof res == 'string') {
      // this.createCourseForm.controls['url'].setValue(GlobalConstants.staticFilesURL + res);
      this.courseImage = res;
    }
  }

  //get internal trainners
  getInternalTrainers = async () => {
    try {

      this.externalTrainers = []
      this.internalTrainers = []

      let query: any = {
        'externalUser.role': 'trainer'
      }

      // if (this.branchId && this.trainingType != 'New Branch') {
      //   query.ou = this.branchId
      // }

      let res = await this.dataService.postData('user/get', query);
      if (res.error) return

      res?.data.forEach((item: any) => {
        let trainer = {
          name: `${item?.name?.first}  ${item?.name?.middle} ${item?.name?.last}`,
          user_id: item._id,
          company_id: item?.externalUser?.company?._id,
          email: item?.email
        }
        if (!!item.externalUser.status) {
          this.externalTrainers.push(trainer)
        } else {
          this.internalTrainers.push(trainer)
        }
      });

    } catch (error) {
      console.log(error)
    }
  }

  async assNewTrainers(list: any) {
    if (list.emit == false) {
      this.addTrainerModal = false
    }
    const arrayOfIds = list.users.map((obj: any) => obj._id);
    try {
      let res: any = await this.dataService.postData('user/add-trainer', arrayOfIds, 'PUT', false);
      if (res.error) {
        return
      }
      else {
        this.addTrainerModal = false
        this.getInternalTrainers();
      }
    } catch (error) {
      console.log(error)
    }
  }


  //creating validation object for training
  constructForObject() {
    this.createCourseForm = this.formBuilder.group({
      title: [null, [Validators.required, Validators.minLength(3)]],
      description: [null, [Validators.required]],
      timeline: [null, [Validators.required]]
    });

    // this.createSessionForm = this.formBuilder.group({
    //   title: [null, [Validators.required, Validators.minLength(3)]],
    //   type: [null, [Validators.required]],
    //   date: [null, [Validators.required]],
    //   start_time: [null, [Validators.required]],
    //   end_time: [null, [Validators.required]]
    // });

    // this.createProgramForm = this.formBuilder.group({
    //   trainer: [null, [Validators.required, Validators.minLength(3)]],
    //   is_online: [null, []],
    //   is_video: [null, []],
    //   video_url: [null, []],
    //   zoom_url: [null, []],
    //   houseNumber: [null, []],
    //   street: [null, []],
    //   city: [null, []],
    // });

  }

  //get all cities
  async getCity() {
    try {
      let res = await this.dataService.getData('location');
      if (!res.error) {
        this.city = res.data.map((location: any) => {
          return {
            value: location.name,
            label: location.name,
            icon: 'pi pi-map-marker',
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  }


  // get training types
  private async getTrainingTypes(): Promise<void> {
    console.log("res.error ===> res.error")
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });

    if (res.error) { return }

    this.trainingTypes = res.data.map((item: any) => {
      return {
        _id: item._id,
        name: item.name,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
        allowed_ou: item.allowed_ou
      };
    });

    if (this.newBranchTraining) {
      let data = res.data.find((e: any) => e.name == 'New Branch');
      this.data = data; //pas permissions to trang detail
    }
    if (this.isSkillTraining) {
      let data = res.data.find((e: any) => e.name == 'Skill Training');
      this.data = data; //pas permissions to trang detail
      this.completeCourseObject.fromSkills = true;
      this.completeCourseObject.dataSkillTraining = res.data;
    }

    console.log("res.error ===> this.trainingTypes", this.trainingTypes)

  }


  branchUser = []

  async getAllBranchUsers(id: any) {
    let res = await this.dataService.postData('user/training-users/', { ous: [this.selectedOus._id], training: id })
    this.branchUser = res.data
  }

  selectedOus: any

  createRequest = async (trainingData: any) => {
    try {

      let data: any;
      if (this.isSkillTraining) {

        let company = "";
        const externalUserString = localStorage.getItem('externalUser');
        if (externalUserString) {
          const externalUser = JSON.parse(externalUserString);
          if (externalUser && externalUser.company) {
            company = externalUser.company;
          }
        }

        data = {
          topic: trainingData.title,
          type: this.skillTypeId,
          description: trainingData.description,
          creator: company
        };

        if (!company) {
          delete data.creator
        }
      }

      if (this.newBranchTraining) {
        data = {
          topic: trainingData.title,
          type: this.trainingTypes.find((e: any) => e.name == 'New Branch')._id,
          description: trainingData.description,

        };

        if (!(!!this.formTrainingProgram)) {
          data.ou = this.selectedOus?._id
        }

      }

      if (this.programOu) {
        data.ous = this.programOu.map((e: any) => e._id)
      }

      let res = await this.dataService.postData('training-req/', data);
      if (res.error) {
        return false
      }
      else {
        return res
      }
    } catch (error) {
      console.log(error);
    }
  };


  // handle form submission  
  async onSubmit() {
    try {



      this.permissions = this.data;

      if (!this.createCourseForm.valid) {
        this.createCourseForm.markAllFieldsTouchedAndDirty();
        return
      }
      this.message = undefined

      if (this.newBranchTraining && !this.selectedOus && !(!!this.formTrainingProgram)) {
        this.message = this.translate('Branch is required')
        return
      }

      // if (this.newBranchTraining) {
      //   this.message = this.translate('The trainer is required')
      //   return
      // }
      // 

      let data: any = this.constructBasicCourseObject(this.createCourseForm.value)
      this.loading = true;
      let request: any
      if (this.isSkillTraining) {
        request = await this.createRequest(data)
        data.request_id = request.data._id;
        request ? this.getTrainingTypes() : '';
        if (request == false) return
      }
      if (this.newBranchTraining) {
        request = await this.createRequest(data)
        if (!(!!this.formTrainingProgram)) {
          await this.getAllBranchUsers(request.data._id)
        }
        data.request_id = request.data._id;
        data.attendees = this.branchUser.map((e: any) => e._id)
      }
      //set active false
      data.active = false
      if (this.data == undefined) {
        data.active = true
      }
      let response: any = await this.dataService.postData('course/', data);
      if (response.error == true) {
        this.message = response.msg;
      } else {
        this.completeCourseObject = data
        this.completeCourseObject._id = response.data._id;
        this.completeCourseObject.fromCreateCourse = true;
        if (this.data || this.data != undefined || this.isSkillTraining || this.newBranchTraining) {
          let req: any = {
            _id: this.isSkillTraining || this.newBranchTraining ? request?.data?._id : this.data._id,
            status: 'TRAINING_CREATED',
            trainingId: response.data._id,
            createdType: 'COURSE',
            //have to add trining id here
          }

          if (this.trainer) {
            req.master_trainer = this.trainer.user_id
          }

          let res = await this.dataService.postData('training-req/', req, 'PUT', false);

          if (this.trainer) {
            await this.setMasterTrainerFlag({ _id: this.trainer.user_id, flag: true })
          }

        }
        //updating request

        let trainingPageData = {
          _id: response.data._id,
          flag: 'EDIT'
        }

        this.loading = false;
        this.navigateToTrainingPage(trainingPageData);

        // this.step = this.steps[1];
      }
    } catch (error) {
      this.loading = false;
      console.log(error)
    }

  }

  async setMasterTrainerFlag(data: any) {
    try {
      let res = await this.dataService.postData("user/master_trainer", data, 'PUT', false)
      return res
    } catch (error) {
      console.log(error)
    }
  }

  navigateToTrainingPage(params: any) {
    const trainingId = params._id;
   //debugger
    const url = this.router.createUrlTree(['/training/training-page', trainingId], { queryParams: params }).toString();
    // if (this.formTrainingProgram) {
    //   window.open(url, '_blank');
    //   this.trainingCreated.emit(true)
    // } else
    if (this.formTrainingProgram || this.openComponent) {
      this.trainingCreated.emit(params)
     //debugger
    }
    else {
      this.router.navigate(['/training/training-page', trainingId], { queryParams: params });
    }
  }

  constructBasicCourseObject(form: any) {

    if (form.timeline) { }

    //checking day friday or sat.. training shift to sunday/next week
    if (this.data?.type?.number_of_sessions == 1) {
      if (form.timeline.getDay() === 5) {
        form.timeline.setDate(form.timeline.getDate() + 2);
      }

      else if (form.timeline.getDay() === 6) {
        form.timeline.setDate(form.timeline.getDate() + 1);
      }
    }

    else {
      if (form.timeline[0].getDay() === 5) {
        form.timeline[0].setDate(form.timeline[0].getDate() + 2);
        form.timeline[1].setDate(form.timeline[1].getDate() + 2);
      }
      else if (form.timeline[0].getDay() === 6) {
        form.timeline[0].setDate(form.timeline[0].getDate() + 1);
        form.timeline[1].setDate(form.timeline[1].getDate() + 1);
      }

    }

    let start: Date = this.data?.type?.number_of_sessions == 1 ? form.timeline : form.timeline[0];
    let end: Date = this.data?.type?.number_of_sessions == 1 ? form.timeline : form.timeline[1];

    start.setHours(0)
    start.setMinutes(0)
    start.setSeconds(0)
    start.setMilliseconds(0)

    end.setHours(0)
    end.setMinutes(0)
    end.setSeconds(0)
    end.setMilliseconds(0)

    return {
      title: form.title,
      request_id: this.data != null || this.data != undefined ? this.data._id : null,
      description: form.description,
      image: this.courseImage,
      courseMaterial: this.courseMaterial,
      start_date: this.datePipe.transform(start, 'yyyy-MM-dd HH:mm:ss', 'Asia/Riyadh'),
      end_date: this.datePipe.transform(end, 'yyyy-MM-dd HH:mm:ss', 'Asia/Riyadh'),
      session: [],
      type: this.data?.type?.name ? this.data?.type?.name : this.data?.name

    }
  }

  adjustToSaudiTime(date: Date): Date {
    // Adjust to Saudi time (UTC+3)
    const utcDate = new Date(date.toISOString()); // Ensure UTC time
    return new Date(utcDate.getTime() + 3 * 60 * 60 * 1000); // Add 3 hours
  }


  completeCourseObject: any

  //creating complete training object with sessions
  constructCourseObject() {


    // console.log("===>Course next step" )

    // this.createCourseForm.value.timeline[1];

    // if( this.step.value == 1 && this.createCourseForm.value.timeline[1] == null){
    //   console.log("===>Course next step 2" )

    //   return
    // }

    // console.log("===>Course next step 3" )
    // //changing Step
    // this.step = this.steps[this.step.value]; 
    // // if(this.step.value < 3) return
    // this.completeCourseObject = this.constructBasicCourseObject(this.createCourseForm.value);
    // this.completeCourseObject.session = this.totalSessions

    // console.log("COmplete Course Object ===88 ",this.completeCourseObject)


  }


  // Add files handler
  addFiles(data: any) {
    this.courseMaterial.push({
      url: data,
      title: this.fileName
    })

    this.fileName = ''
    this.videoUploadSpinner = false
  }


  addVedio(data: any) {
    this.createProgramForm.patchValue({
      video_url: data
    });
    this.videoUploadSpinner = false
  }

  reload() {
    if (this.formTrainingProgram) {
      this.trainingCreated.emit(false)
      return
    }
    window.location.reload();
  }

  dateValidate(SelectedDate: any) {
    let today = new Date();
    this.monthDateError = false
    //check date  range
    if (this.data?.type?.number_of_sessions != 1) SelectedDate = this.createCourseForm.value.timeline[0];

    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (today.getDay() + 2) % 7);


    // Set the end of the week to the next Thursday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    if (SelectedDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
      this.invalidDate = "The Date Has Passed";
      this.createCourseForm.controls['timeline'].setValue(null);
      return

    }

    const selectedDay = SelectedDate.getDay();

    // if (selectedDay === 5 || selectedDay === 6) { // 5 is Friday, 6 is Saturday
    //   this.invalidDate = "Please select a date other than Friday or Saturday";
    //   this.createCourseForm.controls['timeline'].setValue(null);
    //   return
    //     ;
    // }


    // else 
    if (this.data?.type?.name == "WEEKLY" && !(SelectedDate >= startOfWeek && SelectedDate <= endOfWeek)) {
      this.invalidDate = this.translate("invalid Date select in current week");
      this.createCourseForm.controls['timeline'].setValue(null);

    }

    else if (this.data?.type?.name == "Unified session") {

      if (SelectedDate.getFullYear() != this.data?.date?.year || SelectedDate.getMonth() + 1 != this.data?.date?.id) {
        this.invalidDate = this.translate("invalid Date select in assigned Month") + this.data?.date?.id;
        this.createCourseForm.controls['timeline'].setValue(null);
        this.monthDateError = true
      }

      else this.invalidDate = "";

    }
    else if (this.dateType == "range" && !this.createCourseForm.value.timeline[1]) {
      this.createCourseForm.value.timeline
      this.invalidDate = this.translate("invalid Date select in range");

    }
    else this.invalidDate = "";
  }

  monthDateError = false

  async getTreeData() {
    let data: any = await await this.orgUnits.getOrgUnits()
    this.selectedTreeData = []

    //get weekly type
    let selectedid: any = this.trainingTypes.find((e: any) => e.name == 'New Branch').allowed_ou


    if (selectedid.label != 'الجهات المشاركة') {

      this.selectedTreeData.push(this.findNodeByName(data, selectedid._id))
      // Create a deep copy of the selected data using lodash.clonedeep
      this.selectedTreeData_orginal = cloneDeep(this.selectedTreeData);

      const uniqueTags = new Set()

      this.types.forEach((type: any) => {
        if (type && type.tag) {
          uniqueTags.add(type.tag);
        }
      });

      let uniqueTagsArray: MenuItem[] = []

      uniqueTags.forEach((item: any) => {
        if (item != "Ministries/Entities")
          uniqueTagsArray.push({ label: item });
      })

      this.selectedTreeTags = uniqueTagsArray;

      this.selectedTreeTags_current = this.selectedTreeTags[0]

      this.changeSelectedTag(this.selectedTreeTags_current);

    }

  }


  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node._id === nodeName) {
        return node;
      }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Branches"
    };
    if (this.selectedTreeTags_current.label) {
      await this.filterTreeByTag("Branches");
    } else {
      this.selectedTreeData = null;
    }

  }

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);

      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }
  datePipe: DatePipe = new DatePipe(this.locale)

  // disbleDates(values: any) {
  //   let date = new Date(values.year, values.month, values.day, 0, 0, 0)
  //   return [0, 5, 6].includes(date.getDay())
  // }


  disbleDates(values: any) {
    let temp = new Date();
    let today = new Date(temp.getFullYear(), temp.getMonth(), temp.getDate(), 0, 0, 0);

    let SelectedDate = new Date(values.year, values.month, values.day, 0, 0, 0)
    if (SelectedDate.getTime() < today.getTime()) {
      return true;
    }
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - (today.getDay() + 2) % 7);
    // Set the end of the week to the next Thursday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    if (SelectedDate < today) {
      return
    }
    const selectedDay = SelectedDate.getDay();
    // if (selectedDay === 5 || selectedDay === 6) { // 5 is Friday, 6 is Saturday
    //   return false;
    // }
    // else
    if (this.data?.type?.name == "WEEKLY" && !(SelectedDate >= startOfWeek && SelectedDate <= endOfWeek)) {
      return true;
    }
    else if (this.data?.type?.name == "Unified session") {
      if (SelectedDate.getFullYear() != this.data?.date?.year || SelectedDate.getMonth() + 1 != this.data?.date?.id) {
        return true;
      }
      else {
        return false;
      };
    }
    else return false;
  }




}